import { Btn } from "@dolthub/react-components";
import { BsChevronLeft } from "@react-icons/all-files/bs/BsChevronLeft";
import { BsChevronRight } from "@react-icons/all-files/bs/BsChevronRight";
import { GoPrimitiveDot } from "@react-icons/all-files/go/GoPrimitiveDot";
import cx from "classnames";
import React, { useState } from "react";
import FeaturedBlog from "./FeaturedBlog";
import * as css from "./FeaturedBlogs.module.css";

type Props = {
  nodes: Queries.Maybe<
    ReadonlyArray<Queries.Maybe<Queries.SitePageContextBlogs>>
  >;
};

export default function FeaturedBlogs(props: Props) {
  const featured = props.nodes;
  const [showing, setShowing] = useState(0);
  const numFeatured = featured?.length ?? 0;

  return (
    <div className={css.container} data-cy="featured-blogs">
      <div className={css.buttons}>
        <div className={css.innerButtons}>
          <Btn
            onClick={() => {
              setShowing(showing === 0 ? numFeatured - 1 : showing - 1);
            }}
            className={css.arrow}
          >
            <BsChevronLeft />
          </Btn>
          <Btn
            onClick={() => {
              setShowing(showing === numFeatured - 1 ? 0 : showing + 1);
            }}
            className={css.arrow}
          >
            <BsChevronRight />
          </Btn>
        </div>
      </div>
      <ol>
        {featured?.map(
          (f, i) =>
            f?.node &&
            i === showing && (
              <FeaturedBlog
                data={f.node}
                key={f.node.fields?.slug ?? i}
                elementType="li"
              />
            )
        )}
      </ol>
      <div className={css.dots}>
        <ul className={css.innerDots}>
          {featured?.map((f, i) => (
            <li
              key={`dot-${f?.node?.frontmatter?.title ?? i}`}
              className={cx(css.dot, { [css.activeDot]: showing === i })}
            >
              <Btn onClick={() => setShowing(i)}>
                <GoPrimitiveDot />
              </Btn>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
